
import { Component, Prop, Vue } from 'vue-property-decorator';
import WPXForm, { WPXFormValue } from '@/components/templates/WPXForm';
import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { FolderTreeBranch } from '@/components/file-browser/FileBrowser.vue';

export class CreateFolderForm {
  public name: string = '';
  public private: boolean = false;
  public parent?: number = 0;

  public rules: { [key: string]: FormValidationFunction[] } = {
    name: [
      (v: string) => !!v || 'Folder name is required',
      (v: string) => v.length >= 2 || 'Folder name should be at least 2 characters long',
    ],
  };
}

@Component({
  components: { WPXForm },
})
export default class CreateFolder extends Vue {
  private form: WPXFormValue<CreateFolderForm> = new WPXFormValue(CreateFolderForm);

  @Prop({ required: false })
  private readonly parent?: FolderTreeBranch;

  private mounted(): void {
    this.form.data.parent = this.parent ? Number(this.parent.id) : undefined;

    if (this.parent?.folder?.private) {
      this.form.data.private = true;
    }
  }

  private submit(): void {
    this.$emit('create-folder', this.form.data);
  }
}

